import { __extends } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import styles from './Table.module.scss.js';

var TableHeadCell = (function (_super) {
    __extends(TableHeadCell, _super);
    function TableHeadCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableHeadCell.prototype.render = function () {
        var _a, _b;
        var classNameTh = classNames(styles.th, styles[this.props.modify], (_a = {},
            _a[styles.hide] = this.props.isHidden,
            _a), this.props.className);
        var classNameSorter = classNames(styles.sorter, (_b = {},
            _b[styles.isSortable] = this.props.isSortable,
            _b[styles.isActive] = this.props.isActive,
            _b));
        return (React.createElement("div", { className: classNameTh, style: this.props.onClick ? {} : { alignItems: 'center' } }, this.props.onClick ? (React.createElement("div", { className: classNameSorter, onClick: this.props.onClick, style: this.props.align ? { justifyContent: "" + this.props.align } : {} }, this.props.children)) : (this.props.children)));
    };
    return TableHeadCell;
}(React.PureComponent));

export { TableHeadCell as default };
//# sourceMappingURL=TableHeadCell.js.map
